// This section has been removed - content moved to Instagram Gallery
// Keeping file for potential future use

const BlogArticles = () => {
  return null;
};

export default BlogArticles;
